import { render, staticRenderFns } from "./MoreContent.vue?vue&type=template&id=00280c32&scoped=true"
import script from "./MoreContent.vue?vue&type=script&lang=js"
export * from "./MoreContent.vue?vue&type=script&lang=js"
import style0 from "./MoreContent.vue?vue&type=style&index=0&id=00280c32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00280c32",
  null
  
)

export default component.exports